(function () {
  // Phase B-3 WD referral attribution.
  // Reads ?ref=<token> from URL, persists to cookie + localStorage,
  // and writes to cart attribute __ref via Shopify Ajax API.
  // The discount code itself is the authoritative attribution signal
  // (cart attribute is hint only). Same-origin fetch only.

  // Multibrand § F: the cookie domain rides the script tag's
  // data-wd-cookie-domain attribute (rendered only when the Brand setting
  // wd_cookie_domain is set); absent = the EN default below, so an
  // unconfigured store behaves exactly as before. (This file is the
  // brand-sentinel's ONE documented foreign-literal exception; keep the
  // domain literal to a single occurrence.)
  var COOKIE_DOMAIN = '.thecosmicupdate.com';
  try {
    var cfgEl = document.querySelector('script[data-wd-cookie-domain]');
    var cfgDomain = cfgEl && cfgEl.getAttribute('data-wd-cookie-domain');
    if (cfgDomain) COOKIE_DOMAIN = cfgDomain;
  } catch (e) { /* keep the default */ }

  function setCookie(name, value, days) {
    try {
      var expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      // F-C4-04: mirror the server-set wd_ref cookie attributes —
      // Secure (HTTPS pages only) and Domain=<brand apex> so the cookie is
      // shared across apex + my.* subdomain. Server-set cookie attributes
      // are defined in backend app/referral/router.py (per-brand cookie
      // domain settings); client and server must stay mirrored.
      var secure = (window.location.protocol === 'https:') ? ';Secure' : '';
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + expires.toUTCString() +
        ';path=/;Domain=' + COOKIE_DOMAIN + ';SameSite=Lax' + secure;
    } catch (e) { /* cookies disabled */ }
  }

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch (e) { return null; }
  }

  function getRefToken() {
    var urlMatch = window.location.search.match(/[?&]ref=([^&]+)/);
    if (urlMatch && urlMatch[1]) {
      try { return decodeURIComponent(urlMatch[1]); } catch (e) { return urlMatch[1]; }
    }
    try {
      var stored = localStorage.getItem('wd_ref');
      if (stored) return stored;
    } catch (e) { /* localStorage unavailable */ }
    return getCookie('wd_ref');
  }

  function writeCartAttribute(token) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '__ref': token } })
      }).catch(function () { /* best-effort, silent */ });
    } catch (e) { /* fetch unavailable */ }
  }

  var token = getRefToken();
  if (!token) return;

  setCookie('wd_ref', token, 30);
  try { localStorage.setItem('wd_ref', token); } catch (e) { /* private mode */ }

  writeCartAttribute(token);
})();
